import { isEmptyString } from '@/utils';

export function INTERNAL_EMAIL_VALIDATOR(email) {

  const internalEmails = [
    'info@defencehealth.com.au',
    'claims@defencehealth.com.au',
    'hosmedclaims@defencehealth.com.au',
    'hosmedaccounts@defencehealth.com.au',
    'compensation@defencehealth.com.au',
  ];

  if (!isEmptyString(email)) {
    if (internalEmails.includes(email.toLowerCase())) {
      return false;
    }
    return true;
  }

  return true;
};
